export default __webpack_public_path__ + "e2e956cec8e665fdac87364cf73c95eb.mp3";